import { Modal, Button } from 'react-bootstrap';
import useT from '../../i18n/useT';

const AddCity = ({show, setShow, formData, setFormData, submit, loading, type}) => {
    const t = useT();
    return (
        <Modal show={show} onHide={() => setShow(false)} size='lg' centered>
            <Modal.Header closeButton><h3>{type === "edit" ? t("calculator.editTitle") : t("calculator.addTitle")}</h3></Modal.Header>
            <Modal.Body>
                <form className='row' onSubmit={submit}>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("calculator.auction")}:</label>
                            <select className='form-control' required value={formData.auction} onChange={(e) => setFormData((prev) => ({...prev, auction: e.target.value}))}>
                                <option value={""}>{t("calculator.selectAuction")}</option>
                                <option value={"copart"}>Copart</option>
                                <option value={"iaai"}>IAAI</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("calculator.city")}:</label>
                            <input name="city" className='form-control' type='text' required placeholder={t("calculator.enterCity")} value={formData.city} onChange={(e) => setFormData((prev) => ({...prev, city: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("calculator.destination")}:</label>
                            <input name="destination" className='form-control' type='text' required placeholder={t("calculator.enterDestination")} value={formData.destination} onChange={(e) => setFormData((prev) => ({...prev, destination: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("calculator.landPrice")}:</label>
                            <input name="land_price" className='form-control' type='text' required placeholder={t("calculator.enterLandPrice")} value={formData.land_price} onChange={(e) => setFormData((prev) => ({...prev, land_price: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("calculator.containerPrice")}:</label>
                            <input name="container_price" className='form-control' type='text' required placeholder={t("calculator.enterContainerPrice")} value={formData.container_price} onChange={(e) => setFormData((prev) => ({...prev, container_price: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("calculator.totalPrice")}:</label>
                            <input name="total_price" className='form-control' type='text' required placeholder={t("calculator.enterTotalPrice")} value={formData.total_price} onChange={(e) => setFormData((prev) => ({...prev, total_price: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("calculator.port")}:</label>
                            <select name="port" className='form-control' required value={formData.port} onChange={(e) => setFormData((prev) => ({...prev, port: e.target.value}))}>
                                <option value={"(პორტი Washington)"}>{t("calculator.portWA")}</option>
                                <option value={"(პორტი California)"}>{t("calculator.portCA")}</option>
                                <option value={"(პორტი Texas)"}>{t("calculator.portTX")}</option>
                                <option value={"(პორტი Georgia)"}>{t("calculator.portGA")}</option>
                                <option value={"(პორტი Seatle)"}>{t("calculator.portSE")}</option>
                                <option value={"(პორტი New Jersey)"}>{t("calculator.portNJ")}</option>
                            </select>
                        </div> 
                    </div>
                    <Modal.Footer>
                        <Button type='submit' variant={loading ? 'secondary' : 'primary'} disabled={loading}>{loading ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : type === "add" ? t("common.addNew") : t("common.save")}</Button>
                        <Button type='button' onClick={() => setShow(false)} variant='danger'>{t("common.close")}</Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default AddCity;